$(function(){
  //显示折扣码到页面
  showCoupon()
  //显示虚拟变体
  showVirtualVariant()
})
//显示虚拟变体
function showVirtualVariant(){
    let btStr=$('.jerry-variant-box .virtualVariantIpt').val()
    let btArr=parseVirtualVariantStr(btStr)

    if(!btArr){
        return
    }
    let btHtml=createDomForVirtualVariant(btArr)
    $('.jerry-variant-inner-box').html(btHtml)
}
//通过变体信息生成html
function createDomForVirtualVariant(btArr){
    let dom=""
    let currentUrl = window.location.href
    btArr.forEach((bt, index) => {
      if(currentUrl.indexOf(bt.link) !== -1){
      	dom+='<a href="'+bt.link+'" class="jerry-variant-item selected">' + bt.name + '</a>\r\n'
        $(".jerry-variant-box .product-form__option-name").html("Style: "+bt.name)
      }else{
        dom+='<a href="'+bt.link+'" class="jerry-variant-item">' + bt.name + '</a>\r\n'  
      }
    })
    return dom
}
//解析变体信息
function parseVirtualVariantStr(btStr){
  let btArr=[]
  // 根据换行或者回车进行识别
  let btLineList = btStr.split(/[\r\n]+/)
  btLineList.forEach((btLine, index) => {
      //解析单个
      if (btLine) {
          let tmp=btLine.split("||");
          if(tmp[0] && tmp[1] ){
              let bt={"name":tmp[0],"link":tmp[1]}
              btArr.push(bt)
          }
      }
  })
  return btArr
}


/*折扣码倒计时*/
function startCountDown(){
  const timeBoxes = document.querySelectorAll('.time-box');

  const updateCountdown = (element) => {
    const endTimeStr = element.getAttribute('data-endTime');
    const endTime = new Date(endTimeStr).getTime();
    console.log(endTime,"xxaaa")
    if (!endTime) {
      element.style.display = 'none';
      //console.warn(`Invalid endTime for element:`, element);
      return;
    }

    const now = new Date().getTime();
    const timeRemaining = endTime - now;

    if (timeRemaining < 0) {
      element.style.display = 'none';
      return;
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    const timeParts = [];

    if (days > 0) {
      timeParts.push(`${days} Day${days > 1 ? 's' : ''}`);
    }
  
    if (hours > 0 || days > 0) { // Show hours if there are any or if days are present
      timeParts.push(formatTimeUnit(hours));
    }
  
    if (minutes > 0 || (hours === 0 && days === 0)) { // Show minutes if no days or hours
      timeParts.push(formatTimeUnit(minutes));
    }
  
    if (seconds > 0 || timeParts.length === 0) { // Always show seconds if no other parts
      timeParts.push(formatTimeUnit(seconds));
    }

    // 构建最终的显示文本
    let formattedTime = '';
    if (timeParts.length === 1) {
      formattedTime = timeParts[0];
    } else {
      // 如果有天数，先显示天数，再显示其他部分
      if (days > 0) {
        formattedTime = `${timeParts[0]} ${timeParts.slice(1).join(':')}`;
      } else {
        formattedTime = timeParts.join(':');
      }
    }
    
    element.querySelector('.count-down-ctx').textContent = formattedTime;

    // 递归调用 setTimeout 以更新倒计时
    setTimeout(() => updateCountdown(element), 1000);
  };

  // 辅助函数：格式化时间单位为两位数
  const formatTimeUnit = (unit) => unit.toString().padStart(2, '0');

  timeBoxes.forEach(box => {
    const endTimeStr = box.getAttribute('data-endTime');
    const endTime = new Date(endTimeStr).getTime();
    const now = new Date().getTime();
    const timeRemaining = endTime - now;

    if (timeRemaining < 0) {
      box.style.display = 'none';
    } else {
      updateCountdown(box);
    }
  });
}


//显示折扣码到页面
function showCoupon(){
    //这里的数据是从后端读取出来的，格式为【描述:折扣码】,多个折扣码用回车换行隔开
    let promotionModel=$('.jerry-coupon-box .discountInfoIpt').attr("data-promotion-model")
    let couponStr=$('.jerry-coupon-box .discountInfoIpt').val()
    let couponArr=parseCouponStr(couponStr)

    if(!couponArr){
        return
    }
    let couponHtml=promotionModel === "false" ? createDomForCoupon(couponArr) : createDomForCouponOfPromotion(couponArr)
    $('.jerry-coupon-inner-box').html(couponHtml)
    startCountDown()
}
//通过折扣码信息生成html(促销模式)
function createDomForCouponOfPromotion(couponArr){
    let dom=""
    couponArr.forEach((coupon, index) => {
      console.log("促销优惠券信息",coupon)
      dom+='<li class="coupon-item-promotion">'+
        '<div class="coupon-item-ctx">'+
          '<div class="coupon-desc-box">'+
            '<span class="coupon-desc-text">'+ coupon.desc +'</span>'+
            '<span class="code">Code:'+ coupon.code +'</span>'+
          '</div>'+
          '<div class="coupon-copy" onclick="copyCode(event)">'+
            '<span class="copy-tip" data-code="'+ coupon.code +'">COPY</span>'+
          '</div>'+
        '</div>'+
      '</li>\r\n';
    })
    return dom
}

//通过折扣码信息生成html
function createDomForCoupon(couponArr){
    let dom=""
    couponArr.forEach((coupon, index) => {
      console.log("优惠券信息",coupon)
      dom+='<li class="coupon-item">'+
        (coupon.endTime ? '<div class="time-box" data-endTime="'+ coupon.endTime +'"> Ends in <span class="count-down-ctx"></span></div>' : '') +
        '<div class="coupon-item-ctx">'+
          '<div class="coupon-desc-box">'+
            '<span class="coupon-desc-text">'+ coupon.desc +'</span>'+
            '<span class="code">Code:'+ coupon.code +'</span>'+
          '</div>'+
          '<div class="coupon-copy" onclick="copyCode(event)">'+
            '<span class="copy-tip" data-code="'+ coupon.code +'">COPY</span>'+
          '</div>'+
        '</div>'+
      '</li>\r\n';
    })
    return dom
}
//解析折扣码信息
function parseCouponStr(couponStr){
  let couponArr=[]
  // 根据换行或者回车进行识别
  let couponLineList = couponStr.split(/[(\r\n)\r\n]+/)
  couponLineList.forEach((couponLine, index) => {
      //解析单个折扣码
      if (couponLine) {
          let tmp=couponLine.split(";");
          if(tmp[0] && tmp[1] ){
              let coupon={"desc":tmp[0],"code":tmp[1]}
              if(tmp[2]){
                coupon.startTime = tmp[2]
              }
              if(tmp[3]){
                coupon.endTime = tmp[3]
              }
              couponArr.push(coupon)
          }
      }
  })
  return couponArr
}
//复制指定字符串到剪贴板
function copyToClipboard(str) {
  let el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  let selected =
	document.getSelection().rangeCount > 0
	  ? document.getSelection().getRangeAt(0)
	  : false;
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  if (selected) {
	document.getSelection().removeAllRanges();
	document.getSelection().addRange(selected);
  }
}
//复制折扣码
function copyCode(e) {
	let clickedElement = e.currentTarget
	var copyTipDom = clickedElement.querySelector('.copy-tip')
	copyToClipboard(copyTipDom.getAttribute("data-code"));
	copyTipDom.innerHTML = 'COPIED'
	setTimeout(function () {
	copyTipDom.innerText = "COPY";
	}, 1000);
}